export class Model_CRM_Designation{

        public DesigID : number;
        public  Designation : string;
}